export enum UnloadTypePumpCodes {
  PUMP = 'PUMP',
  CEMEX_PUMP = 'CEMEX_PUMP',
  CUSTOMER_PUMP = 'CUSTOMER_PUMP',
  // Fixing BE issues
  BOMBEO = 'BOMBEO',
  BOOM_PUMP = 'PLACING_BOOM_PUMP',
  STATIONARY_PUMP = 'STATIONARY_PUMP',
  SPECIFIC_PUMP = '5',
  // Added for FR
  PUMPING_SERVICE = 'PUMPING_SERVICE',
}

export enum UnloadTypePumpCodesFrance {
  PUMP = 'PUMP',
  CEMEX_PUMP = 'CEMEX_PUMP',
  CUSTOMER_PUMP = 'CUSTOMER_PUMP',
  // Fixing BE issues
  BOMBEO = 'BOMBEO',
  BOOM_PUMP = 'PLACING_BOOM_PUMP',
  STATIONARY_PUMP = 'STATIONARY_PUMP',
  // Added for FR
  PUMPING_SERVICE = 'PUMPING_SERVICE',
  OWN_PUMPING = 'OWN_PUMPING',
}
